import React from 'react';
import { motion } from 'framer-motion';
import { Shield, CreditCard, Briefcase, Building2 } from 'lucide-react';
const partners = [{
  name: 'Absolute Insurance',
  desc: 'Insurance Partner',
  icon: Shield
}, {
  name: 'Real Estate Cashback',
  desc: 'Cashback Program',
  icon: CreditCard
}, {
  name: 'Trustline Capital',
  desc: 'Capital Partner',
  icon: Briefcase
}, {
  name: 'Retrust Microfinance Bank',
  desc: 'Banking Partner',
  icon: Building2
}];
export function Partners() {
  return <section className="py-20 px-6 md:px-12 max-w-[1280px] mx-auto bg-bone" data-id="element-628">
      <div className="text-center mb-12" data-id="element-629">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-xs font-semibold tracking-[0.2em] uppercase text-gold mb-4" data-id="element-630">
          Trusted By
        </motion.div>
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-serif text-ink tracking-tight" data-id="element-631">
          Our Partners
        </motion.h2>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-632">
        {partners.map((p, i) => {
        const Icon = p.icon;
        return <motion.div key={p.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} whileHover={{
          y: -4
        }} className="group relative bg-white border border-ink/5 rounded-2xl p-6 md:p-8 flex flex-col items-center text-center hover:border-gold/40 hover:shadow-md transition-all" data-id="element-633">
              <div className="w-14 h-14 rounded-xl bg-bone-dark flex items-center justify-center mb-4 group-hover:bg-gold transition-colors" data-id="element-634">
                <Icon className="w-7 h-7 text-ink/70 group-hover:text-white transition-colors" strokeWidth={1.5} data-id="element-635" />
              </div>
              <div className="font-serif text-lg text-ink mb-1 leading-tight" data-id="element-636">
                {p.name}
              </div>
              <div className="text-xs text-ink/50 uppercase tracking-wider font-medium" data-id="element-637">
                {p.desc}
              </div>

              {/* Hover accent line */}
              <div className="absolute bottom-0 left-1/2 -translate-x-1/2 h-[2px] bg-gold w-0 group-hover:w-1/2 transition-all duration-500" data-id="element-638" />
            </motion.div>;
      })}
      </div>
    </section>;
}